import { useWindowDimensions } from './useWindowDimensions';

const breakpoints = {
	sm: 480,
};

export const useBreakpoints = () => {
	const { width } = useWindowDimensions();

	return {
		isSm: width < breakpoints.sm,
	};
};
